<zenith-header zn-site-name="QDrive" zn-href="/new">
  <zenith-nav>
    @for (item of navigationItems(); track item.route; ) {
      <zenith-nav-item [attr.zn-active]="rla.isActive">
        <a
          slot="anchor"
          [routerLink]="item.route"
          [routerLinkActive]="'active'"
          #rla="routerLinkActive">
          {{ item.label | translate }}
        </a>
      </zenith-nav-item>
    }
  </zenith-nav>

  <app-impersonation-badge />
  <app-synchronization-status-icon />
  <app-synchronization-online-icon />

  <zenith-drop-menu zn-icon-name="user" [attr.zn-tooltip]="'header.navigation.account' | translate">
    <zenith-drop-menu-item
      zn-icon-name="settings"
      routerLink="/new/account">{{ 'header.navigation.account' | translate }}
    </zenith-drop-menu-item>
    <zenith-drop-menu-item
      zn-icon-name="power"
      (click)="logout()">{{ 'header.navigation.logout' | translate }}
    </zenith-drop-menu-item>
  </zenith-drop-menu>
</zenith-header>